import { useContext, useEffect, useState } from "react"
import { SidePopupLayout, LogFailedTransaction } from "src/component"
import UserContext from "src/provider/state-manager/userProvider"
import ApiContext from "src/provider/API/call-service"
import { AppSpan, AppText, Button, CustomContainer, FlexRow, GridContainer, ScreenTitle } from "src/style"
import {ReactComponent as DownloadIcon} from 'src/assets/img/download-receipt-icon.svg'
import helpers from "src/utils/helpers"
import { moneyFormat } from "src/utils/utility"
import { Reciept } from "src/component"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"


export const TransactionDetails: React.FC<any> = ({data, nuban, close}) => {
    const {API} = useContext(ApiContext)
    const {user: {accountInfo}} = useContext(UserContext)
    const [view, setView] = useState('tx-details')
    const [fetchedTxDetails, setFetchedTxDetails] = useState<any>(null)
    const {info: {institutionData}} = useContext(AppInfoContext)


    useEffect(() => {
        handleFetchTxDetailsByTxRef()
    }, [])

    async function handleFetchTxDetailsByTxRef () {
        if (data?.transactionReference){
            const response = await API.getTransactionByTxRef(data?.transactionReference)
            if (response) setFetchedTxDetails(response)
        }
    }

    let date: any = (data && !data?.transactionDate.includes(' ')) ? helpers.splitDateTime(data?.transactionDate || '0001-01-01T00:00:00.495Z') : data?.transactionDate

    return (
        <>
            { view === 'tx-details' &&
                <SidePopupLayout close={close}>
                    <ScreenTitle textSize="2.2" fontWeight="700">Transaction Details</ScreenTitle>
                    <GridContainer topMargin='2.5'>
                        <CustomContainer
                            minHeight="15.6" borderColor="#EAECF0" padding="2" radius="0.8"
                        >
                            { fetchedTxDetails &&
                                <>
                                    <FlexRow justifyContent="space-between" gap="1.5" wrap="wrap">
                                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                                            <AppSpan>Sender Name</AppSpan>
                                            <AppText fontWeight="700" color="#0D968F">{fetchedTxDetails?.senderAccountName}</AppText>
                                        </GridContainer>
                                        <GridContainer width="auto" sizeUnit="" alignItems="end">
                                            <AppSpan>Sender Acct</AppSpan>
                                            <AppText fontWeight="700" color="#0D968F">{fetchedTxDetails?.senderAccountNumber}</AppText>
                                        </GridContainer>
                                    </FlexRow>
                                    <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                                            <AppSpan>Receiver Name</AppSpan>
                                            <AppText fontWeight="700" color="#0D968F">{fetchedTxDetails?.recipientAccountName}</AppText>
                                        </GridContainer>
                                        <GridContainer width="auto" sizeUnit="" alignItems="end">
                                            <AppSpan>Receiver Acct</AppSpan>
                                            <AppText fontWeight="700" color="#0D968F">{fetchedTxDetails?.recipientAccountNumber}</AppText>
                                        </GridContainer>
                                    </FlexRow>
                                    <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                                            <AppSpan>Receiver Bank</AppSpan>
                                            <AppText fontWeight="700" color="#0D968F">{fetchedTxDetails?.recipientBankName}</AppText>
                                        </GridContainer>
                                        <GridContainer width="auto" sizeUnit="" alignItems="end">
                                            <AppSpan>Narration</AppSpan>
                                            <AppText fontWeight="700" color="#0D968F">{fetchedTxDetails?.narration}</AppText>
                                        </GridContainer>
                                    </FlexRow>
                                    <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                                            <AppSpan>Status</AppSpan>
                                            <AppText fontWeight="700" color="#0D968F">{fetchedTxDetails?.transactionStatus}</AppText>
                                        </GridContainer>
                                    </FlexRow>
                                    <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                                            <AppSpan>Transaction Reference</AppSpan>
                                            <AppText fontWeight="700" color="#0D968F">{fetchedTxDetails?.transactionReference}</AppText>
                                        </GridContainer>
                                    </FlexRow>
                                </>
                            }
                            { !fetchedTxDetails &&
                                <FlexRow justifyContent="space-between" gap="1.5" wrap="wrap">
                                    <GridContainer width="auto" sizeUnit="" alignItems="start">
                                        <AppSpan>Narration</AppSpan>
                                        <AppText fontWeight="700" color="#0D968F">{data?.narration}</AppText>
                                    </GridContainer>
                                    <GridContainer width="auto" sizeUnit="" alignItems="end">
                                        <AppSpan>Sender Acct</AppSpan>
                                        <AppText fontWeight="700" color="#0D968F">{nuban}</AppText>
                                    </GridContainer>
                                </FlexRow>
                            }
                            <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                                <GridContainer width="auto" sizeUnit="" alignItems="start">
                                    <AppSpan>Date & Time</AppSpan>
                                    <AppText fontWeight="700" color="#0D968F">{(data && !data?.transactionDate.includes(' ')) ? `${date?.slashedDate} ${date?.completeTime}` : date}</AppText>
                                </GridContainer>
                                <GridContainer width="auto" sizeUnit="" alignItems="end">
                                    <AppSpan>Amount</AppSpan>
                                    <AppText fontWeight="700" color="#0D968F" >{moneyFormat(fetchedTxDetails?.amount || data?.amount || 0, true,institutionData?.defaultCurrency)}</AppText>
                                </GridContainer>
                            </FlexRow>
                            { !fetchedTxDetails &&
                                <FlexRow justifyContent="space-between" gap="1.5" wrap="wrap" topMargin="1.5">
                                    <GridContainer width="auto" sizeUnit="" alignItems="start">
                                        <AppSpan>Transaction Reference</AppSpan>
                                        <AppText fontWeight="700" color="#0D968F">{data?.transactionReference}</AppText>
                                    </GridContainer>
                                </FlexRow>
                            }
                        </CustomContainer>
                        { fetchedTxDetails &&
                            <FlexRow width="auto" sizeUnit="" gap="1" topMargin="2" className="download-receipt">
                                <DownloadIcon className="icon-component" />
                                {/* <AppText color="#3A3A3A" cursor="pointer" hoverColor="#0D968F">Download Receipt</AppText> */}
                                <Reciept txData={{...fetchedTxDetails, transactionDate: (data && !data?.transactionDate.includes(' ')) ? `${date?.slashedDate} ${date?.completeTime}` : date}}/>
                            </FlexRow>
                        }
                        <Button 
                            width='18.4' height='4' topMargin="2.5"
                            borderColor='#0D968F' hoverBgColor='#ffffff' 
                            hoverColor='#0D968F' titleSize='1.4'
                            onClick={() => setView('log-failed-tx')}
                        >
                            Log Failed Transaction
                        </Button>
                    </GridContainer>
                </SidePopupLayout>
            }
            { view === 'log-failed-tx' &&
                <LogFailedTransaction
                    data={{senderAccountNumber : nuban || accountInfo[0]?.accountNumber,...fetchedTxDetails, ...data}}
                    back={() => setView('tx-details')}
                    close={close}
                />
            }
        </>
    )
}
